import Whisper from './Whisper';

// export types
export type { WhisperProps, WhisperInstance } from './Whisper';

// export components
export { Whisper };
export default Whisper;
